"use client"

import { useEffect, useState, useCallback } from "react"
import { usePathname } from "next/navigation"

const BOTTOM_SRC = "https://1057665e82f.vws.vegacdn.vn/okwinstatic/images/banner-bottom.gif"

export default function BottomBanner() {
  const [visible, setVisible] = useState(true)
  const pathname = usePathname()

  // Always re-show on route change
  useEffect(() => {
    setVisible(true)
  }, [pathname])

  const close = useCallback(() => {
    setVisible(false)
  }, [])

  if (!visible) return null

  return (
    <div className="fixed left-1/2 -translate-x-1/2 bottom-0 z-[900] hidden md:block">
      <div className="relative">
        <button
          onClick={close}
          aria-label="Đóng banner dưới"
          className="absolute w-8 h-8 rounded-full bg-white flex items-center justify-center shadow"
          style={{ top: '-1rem', right: '-1rem' }}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M5.293 5.293a1 1 0 0 1 1.414 0L12 10.586l5.293-5.293a1 1 0 1 1 1.414 1.414L13.414 12l5.293 5.293a1 1 0 0 1-1.414 1.414L12 13.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L10.586 12 5.293 6.707a1 1 0 0 1 0-1.414Z" fill="#0F1729"/>
          </svg>
        </button>
        <a href="https://3456789day.com/?f=2843315" target="_blank" rel="noopener noreferrer">
          <img src={BOTTOM_SRC} alt="Banner dưới" className="block w-auto" />
        </a>
      </div>
    </div>
  )
} 